/* eslint-disable no-bitwise */

export interface SFC32Seed {
  a: number,
  b: number,
  c: number,
  d: number,
}

export function generateRandomSfc32Seed(): SFC32Seed {
  return {
    a: Math.round(Math.random() * 0xFFFFFFFF),
    b: Math.round(Math.random() * 0xFFFFFFFF),
    c: Math.round(Math.random() * 0xFFFFFFFF),
    d: Math.round(Math.random() * 0xFFFFFFFF),
  };
}

// "Small Fast Counter" Pseudo random number generator:
// https://github.com/bryc/code/blob/master/jshash/PRNGs.md#sfc32
export function sfc32(seed: SFC32Seed) {
  let { a, b, c, d } = seed;
  return () => {
    a |= 0; b |= 0; c |= 0; d |= 0;
    const t = (a + b | 0) + d | 0;
    d = d + 1 | 0;
    a = b ^ b >>> 9;
    b = c + (c << 3) | 0;
    c = c << 21 | c >>> 11;
    c = c + t | 0;
    return t >>> 0;
  };
}
